

import { useDispatch, useSelector } from 'react-redux';
import { Controller } from 'react-hook-form';
import { useState } from 'react'

import { getFormErrorMessage } from '../../../config/global';
import { DISPLAY_OPTIONS, POSITION_OPTIONS } from '../../../Constants/apps';
import { setClockSettings, setRssSettings, setWeatherBgColor, setWeatherCardColor, setWeatherTextColor } from '../../../redux/Slices/Apps/appsSlice';
import { InputNumber } from 'primereact/inputnumber';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

import Sketch from '@uiw/react-color-sketch';
import { useTranslation } from 'react-i18next';

const TextColorInput = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const weatherTextColor = useSelector((state) => state.apps.weatherTextColor);
    const [displayColorPicker, setDisplayColorPicker] = useState({
        text: false,
        bg: false
    });

    const colorPickerHandler = (key) => {
        setDisplayColorPicker(prev => ({ ...prev, [key]: !prev[key] }))
    }

    return (
        <>
            <div className="w-50">
                <label className={`block text-sm mb-1`}>{t('weather.text_color')}</label>
                <div className="border-1 p-2 rounded d-flex position-relative">
                    <Sketch
                        color={weatherTextColor}
                        disableAlpha={false}
                        onChange={(color) => {
                            dispatch(setWeatherTextColor(color.hexa))
                        }}
                        onMouseLeave={() => colorPickerHandler("text")}
                        className={`right-[0] position-absolute color_picker ${displayColorPicker.text ? "d-block" : "d-none"}`}
                    />
                    <div className='me-3 cursor-pointer border-1'
                        onClick={() => colorPickerHandler("text")}
                        style={{ backgroundColor: `${weatherTextColor}`, width: "25px", height: "25px" }} >
                    </div>
                    <div className='border-bottom' >{weatherTextColor}</div>
                </div>
            </div>


        </>
    )
}

const BgColorInput = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const weatherBgColor = useSelector((state) => state.apps.weatherBgColor);

    const [displayColorPicker, setDisplayColorPicker] = useState({
        text: false,
        bg: false
    });


    const colorPickerHandler = (key) => {
        setDisplayColorPicker(prev => ({ ...prev, [key]: !prev[key] }))
    }

    const hexToRgba = (hex, alpha = 0.1) => {
        let r = 0, g = 0, b = 0;

        // 3 digits
        if (hex.length === 4) {
            r = parseInt(hex[1] + hex[1], 16);
            g = parseInt(hex[2] + hex[2], 16);
            b = parseInt(hex[3] + hex[3], 16);
        }
        // 6 digits
        else if (hex.length === 7) {
            r = parseInt(hex[1] + hex[2], 16);
            g = parseInt(hex[3] + hex[4], 16);
            b = parseInt(hex[5] + hex[6], 16);
        }

        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };



    return (
        <>


            <div className="w-50">
                <label className={`block text-sm mb-1`}>{t('weather.background_color')}</label>
                <div className="border-1 p-2 rounded d-flex position-relative">
                    <Sketch
                        color={weatherBgColor}
                        disableAlpha={false}
                        onChange={(color) => {
                            const shadowColor = hexToRgba(color.hexa, 0.1)
                            dispatch(setWeatherBgColor(color.hexa))
                            dispatch(setWeatherCardColor(shadowColor))


                        }}
                        onMouseLeave={() => colorPickerHandler("text")}
                        className={`right-[0] position-absolute color_picker ${displayColorPicker.text ? "d-block" : "d-none"}`}
                    />
                    <div className='me-3 cursor-pointer border-1'
                        onClick={() => colorPickerHandler("text")}
                        style={{ backgroundColor: `${weatherBgColor}`, width: "25px", height: "25px" }} >
                    </div>
                    <div className='border-bottom' >{weatherBgColor}</div>
                </div>
            </div>

        </>
    )
}


export { TextColorInput, BgColorInput }